import {
  Bot,
  Camera,
  FileScan,
  MapPinPlus,
  Mic,
  NotebookPen,
  Share2,
  Video,
  Images,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type LiveQuickActionId =
  | 'photo'
  | 'video'
  | 'voice'
  | 'note'
  | 'add_place'
  | 'scan_doc'
  | 'ai'
  | 'share_location'
  | 'view_photos'

interface ActionDef {
  id: LiveQuickActionId
  label: string
  Icon: LucideIcon
}

const ACTIONS: ActionDef[] = [
  { id: 'photo', label: 'Photo', Icon: Camera },
  { id: 'video', label: 'Video', Icon: Video },
  { id: 'voice', label: 'Voice', Icon: Mic },
  { id: 'note', label: 'Note', Icon: NotebookPen },
  { id: 'add_place', label: 'Add place', Icon: MapPinPlus },
  { id: 'scan_doc', label: 'Scan doc', Icon: FileScan },
  { id: 'ai', label: 'Ask AI', Icon: Bot },
  { id: 'view_photos', label: 'Photos', Icon: Images },
  { id: 'share_location', label: 'Share', Icon: Share2 },
]

interface LiveQuickGridProps {
  onAction: (id: LiveQuickActionId) => void
  /** When false, photo/video/note/scan require a focus point. */
  attachDisabled?: boolean
  busyAction?: LiveQuickActionId | null
}

const NEEDS_FOCUS: LiveQuickActionId[] = ['photo', 'video', 'note', 'scan_doc']

export function LiveQuickGrid({ onAction, attachDisabled, busyAction }: LiveQuickGridProps) {
  return (
    <section aria-label="Quick actions">
      <h2 className="mb-2 text-sm font-semibold text-st-text">Quick actions</h2>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        {ACTIONS.map(({ id, label, Icon }) => {
          const busy = busyAction === id
          const disabled = attachDisabled && NEEDS_FOCUS.includes(id)
          return (
            <button
              key={id}
              type="button"
              disabled={disabled || busy}
              onClick={() => onAction(id)}
              className="flex min-h-14 flex-col items-center justify-center gap-1 rounded-st-md border border-st-line bg-st-surface px-2 py-2 text-center text-xs font-medium text-st-text transition hover:bg-st-surface-2 disabled:cursor-not-allowed disabled:opacity-50 sm:min-h-[3.5rem]"
            >
              <Icon className="h-5 w-5 text-st-primary" aria-hidden />
              <span>{busy ? '…' : label}</span>
            </button>
          )
        })}
      </div>
    </section>
  )
}
